import WorldPinImage from '@shared/assets/images/v2/world-pin.svg';
import { AnchoredSheet } from '@shared/components/AnchoredSheet';
import { Button } from '@shared/components/Button';
import { Image } from '@shared/components/Image';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import classNames from './PromptBottomSheetContent.module.css';

interface Props {
  anchorName: string;
  onClose(): void;
  onPress(): void;
}

export function PromptBottomSheetContent({ anchorName, onPress, onClose }: Props) {
  return (
    <AnchoredSheet
      anchorName={anchorName}
      title={i18n('card.blocks.geolocationInput.prompt.title')}
      onClose={onClose}
    >
      <View padding={4} style={{ width: 320, alignSelf: 'center' }}>
        <Text size="body1" align="center">
          {i18n('card.blocks.geolocationInput.prompt.description')}
        </Text>
        <View paddingTop={4} />
        <Image source={WorldPinImage} className={classNames.image} resizeMode="contain" />
        <View paddingTop={4} />
        <Button
          variant="primary"
          size="jumbo"
          label={i18n('card.blocks.geolocationInput.prompt.cta')}
          onClick={onPress}
        />
      </View>
    </AnchoredSheet>
  );
}
